import { ContentMetaData } from 'src/utils/ConsumptionHelper/types';
import {
  getSessionStorage,
  setSessionStorage
} from 'src/utils/browserStorageHandler';
import { SEARCH_LANDING_DATA } from 'src/utils/constants/localStorageConstants';

export const storeSearchLandingDataToSessionStorage = (
  data: ContentMetaData
) => {
  try {
    setSessionStorage(SEARCH_LANDING_DATA, JSON.stringify(data));
  } catch (e) {
    console.error('Error while storing SearchLanding data: ', e);
  }
};

export const getSearchLandingDataFromSessionStorage = () => {
  const data = getSessionStorage(SEARCH_LANDING_DATA);
  let parsedData = [];
  if (data) {
    try {
      parsedData = JSON.parse(data);
    } catch (err) {
      console.error('Error while fetching searchLanding data: ', err);
    }
  }
  return parsedData;
};
